import contact_header_back from "./contact_header_back.webp";

// const contact_header_back = "https://firebasestorage.googleapis.com/v0/b/payeplast-web.appspot.com/o/images%2FcontactImg%2Fcontact_header_back.png?alt=media&token=9938adc4-5272-44d7-b7af-25cabdfe5a48"

export const contactImages = {
  contact_header_back,
};
